<template>
  <form class="subscription-form" :aria-busy="busy || loadingTypes" @submit.prevent="submit">
    <div class="subscription-form__grid">
      <app-form-field design="new" label="Hotel" :label-for="`${idPrefix}-property`" required>
        <app-select design="new" aria-label="Hotel" :input-id="`${idPrefix}-property`" v-model="form.property" :options="properties" label="name" :reduce="item => item.code" :clearable="false" @input="changeProperty" />
      </app-form-field>
      <app-form-field design="new" label="Room type" :label-for="`${idPrefix}-room_type`" required>
        <div v-if="loadingTypes" class="subscription-form__skeleton" role="status" aria-label="Loading room types"><span aria-hidden="true" /></div>
        <app-select v-else design="new" aria-label="Room type" :input-id="`${idPrefix}-room_type`" v-model="form.room_type" :options="roomTypes" label="name" :reduce="item => item.id" :clearable="false" :disabled="loadingTypes" />
      </app-form-field>
      <app-form-field design="new" label="Check-in" :label-for="`${idPrefix}-check_in`" required>
        <app-date-picker design="new" :input-attr="{ id: `${idPrefix}-check_in` }" v-model="form.check_in" :clearable="false" />
      </app-form-field>
      <app-form-field design="new" label="Check-out" :label-for="`${idPrefix}-check_out`" required>
        <app-date-picker design="new" :input-attr="{ id: `${idPrefix}-check_out` }" v-model="form.check_out" :clearable="false" />
      </app-form-field>
      <app-form-field design="new" label="Rooms required" :label-for="`${idPrefix}-required_rooms`" required>
        <app-input design="new" :id="`${idPrefix}-required_rooms`" v-model.number="form.required_rooms" type="number" min="1" step="1" />
      </app-form-field>
    </div>
    <p class="subscription-form__hint">Check-in must be between tomorrow and one year from today. Availability is checked every three hours until check-in. Rooms are not reserved.</p>
    <p v-if="editing" class="subscription-form__hint">Changing the conditions does not extend the monitoring period.</p>
    <p v-if="error" role="alert" class="subscription-form__error">{{ error }}</p>
    <div v-if="typesError" role="alert" class="subscription-form__error"><p>{{ typesError }}</p><app-button design="new" theme="dark" type="button" @click.native="loadTypes">Retry</app-button></div>
    <app-button ref="submit" design="new" type="submit" :aria-busy="busy" :aria-label="submitLabel" :disabled="busy || loadingTypes || !!typesError">{{ submitLabel }}</app-button>
  </form>
</template>

<script>
import { getHotelManagementCalendarRoomTypes } from '@/http'

export default {
  name: 'AvailabilitySubscriptionForm',
  props: {
    initial: { type: Object, default: () => ({}) },
    editing: { type: Boolean, default: false },
    busy: { type: Boolean, default: false },
  },
  data() {
    return {
      idPrefix: `availability-form-${this._uid}`,
      typesError: '',
      form: { property: 'aishi', room_type: null, check_in: null, check_out: null, required_rooms: 1, ...this.initial },
      properties: [{ code: 'aishi', name: 'Aishi' }, { code: 'brubru', name: 'Brubru' }],
      roomTypes: [],
      loadingTypes: false,
      error: '',
    }
  },
  computed: {
    submitLabel() { return this.editing ? 'Save changes' : 'Subscribe and connect Telegram' },
  },
  watch: {
    busy(value) { if (this.$refs.submit) this.$refs.submit.preload = value },
  },
  mounted() {
    this.loadTypes()
  },
  methods: {
    changeProperty() {
      this.form.room_type = null
      this.loadTypes()
    },
    async loadTypes() {
      const property = this.form.property
      this.loadingTypes = true
      this.typesError = ''
      try {
        const { data } = await getHotelManagementCalendarRoomTypes(property)
        if (property === this.form.property) this.roomTypes = data
      } catch (error) {
        this.typesError = 'Room types could not be loaded. Please try again.'
      } finally {
        if (property === this.form.property) this.loadingTypes = false
      }
    },
    submit() {
      this.error = ''
      if (!this.form.room_type || !this.form.check_in || !this.form.check_out || Number(this.form.required_rooms) < 1) {
        this.error = 'Select a room type, dates and at least one room.'
        return
      }
      const { property, room_type, check_in, check_out, required_rooms } = this.form
      const payload = { property, room_type, check_in, check_out, required_rooms: Number(required_rooms) }
      this.$emit('save', payload)
    },
  },
}
</script>

<style lang="scss" scoped>
.subscription-form { color: $ui-text; font: $ui-font-size-body $ui-font-body; line-height: 1.45; }
.subscription-form__grid { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: $ui-space-16; }
.subscription-form__grid > * { min-width: 0; }
.subscription-form__hint { color: $ui-muted; margin: $ui-space-16 0; font-size: $ui-font-size-metadata; line-height: 1.5; }
.subscription-form__error { color: $ui-red; margin-bottom: $ui-space-16; }
.subscription-form__skeleton span { display: block; height: $ui-control-height; border-radius: $ui-control-radius; background: $ui-line; }
@media (max-width: 600px) { .subscription-form__grid { grid-template-columns: minmax(0, 1fr); } }
</style>
